import { FC } from 'react';
import { TabPanelProps } from './types';
import { Box } from '@material-ui/core';

const TabPanel: FC<TabPanelProps> = ({ children, value, index, ...other }) => (
  <div
    role='tabpanel'
    hidden={value !== index}
    id={`wrapped-tabpanel-${index}`}
    aria-labelledby={`wrapped-tab-${index}`}
    {...other}>
    {value === index && <Box py={4}>{children}</Box>}
  </div>
);

export default TabPanel;
